import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';



export class ChapterTwelve extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>

        <TextHolder text="The internet is powerful. But there was one thing its search engines could not find: a comprehensive report on the tech, startup, funding and regulatory ecosystem of SEA."/>

              <TextHolder text="It probably did not exist. What do you do if you cannot find what you are looking for? You create it."/>

              <TextHolder text="Together with our partner Monk’s Hill Ventures, we took on a quest to map out the SEA startup ecosystem and create an overview on funding, trending sectors and future growth projections for the region. As we reached out to other partners for help with data, surveys, interviews and distribution, we realized that this report was long overdue. Many of our partners shared our enthusiasm for undertaking this report and supported us where they could."/>

              <TextHolder text="Why is this report so important?"/>

              <TextHolder text="With its emerging market of over 600 million people, it’s time for SEA tech startup ecosystem to be recognized globally. The region is on the cusp of becoming one of the key global technology startup hubs. With access to world-class tech talent and tremendous funding opportunities, there is a high chance the next big thing in tech will come from SEA."/>

              <TextHolder text="Many companies stand to miss out on these opportunities because of a lack of knowledge. This report aims to fix that."/>

              <TextHolder text="Whether you are from this region or from outside of it, we hope this report will provide a good starting point to understand the region’s tech startup landscape and the opportunities. To help you better navigate the report, you may visit www.thesoutheastasia.com, where you may also download a PDF of the report. We hope it will serve as a reference point for investors, entrepreneurs and the media."/>

              <TextHolder text="This report is the first big step towards putting SEA on the map, and we’re already looking towards the next edition."/>

              <TextHolder text="We hope you enjoy the report!"/>

              <TextHolder textTitle="Anna Ratala"/>
              <TextHolder textTitle="Head of Slush Singapore"/>
              <TextHolder text="" />
          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/12.js